module.exports = __webpack_public_path__ + "img/card_background.22bdccdb.png";